// language=GraphQL
const userFinancingQuery = `
  query ($userId: ID!) {
    aCustomer(userId: $userId) {
      financing {
        isValid
      }
    }
  }
`;

export default userFinancingQuery;
